module.exports = __webpack_public_path__ + "media/stylesheets/images/star-rating/star-half-1ce8296a2193794218d5efce30e8aec1.svg";